function initMainSlider(root) {
  const track = root.querySelector('.main-slider__track');
  const trackOuter = root.querySelector('.main-slider__track-outer');
  const slides = Array.from(root.querySelectorAll('.main-slider__slide'));
  const prevBtn = root.querySelector('.main-slider__arrow--prev');
  const nextBtn = root.querySelector('.main-slider__arrow--next');
  const dotsWrap = root.querySelector('.main-slider__dots');
  const counterCurrent = root.querySelector('.main-slider__counter-current');
  const counterTotal = root.querySelector('.main-slider__counter-total');

  if (!track || slides.length === 0) return;

  const autoscroll = root.dataset.autoscroll === 'true';
  const loop = root.dataset.loop === 'true';
  const speed = parseInt(root.dataset.speed, 10) || 5000;
  const isAdapt = root.classList.contains('main-slider--adapt');
  const total = slides.length;

  let currentIndex = 0;
  let timer = null;

  function syncAdaptRatio() {
    if (!isAdapt || !trackOuter) return;
    const slide = slides[currentIndex];
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const ratio = isMobile
      ? slide.dataset.ratioMobile || slide.dataset.ratioDesktop
      : slide.dataset.ratioDesktop;
    if (ratio) trackOuter.style.setProperty('--current-ratio', ratio);
  }

  function buildDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'main-slider__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        go(i);
      });
      dotsWrap.appendChild(dot);
    }
  }

  function update() {
    track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';
    syncAdaptRatio();

    if (prevBtn) prevBtn.disabled = !loop && currentIndex === 0;
    if (nextBtn) nextBtn.disabled = !loop && currentIndex === total - 1;

    if (dotsWrap) {
      Array.from(dotsWrap.children).forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    if (counterCurrent) counterCurrent.textContent = currentIndex + 1;
    if (counterTotal) counterTotal.textContent = total;
  }

  function go(index) {
    if (loop) {
      currentIndex = (index + total) % total;
    } else {
      currentIndex = Math.max(0, Math.min(index, total - 1));
    }
    update();
    if (autoscroll) {
      stopAuto();
      startAuto();
    }
  }

  function startAuto() {
    if (!autoscroll || total <= 1) return;
    stopAuto();
    timer = setInterval(function () {
      if (!loop && currentIndex === total - 1) {
        go(0);
      } else {
        go(currentIndex + 1);
      }
    }, speed);
  }

  function stopAuto() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { go(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { go(currentIndex + 1); });

  root.addEventListener('mouseenter', stopAuto);
  root.addEventListener('mouseleave', startAuto);
  root.addEventListener('focusin', stopAuto);
  root.addEventListener('focusout', startAuto);

  let touchStartX = 0;
  root.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    stopAuto();
  }, { passive: true });

  root.addEventListener('touchend', function (e) {
    const diff = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(diff) > 40) {
      diff > 0 ? go(currentIndex - 1) : go(currentIndex + 1);
    } else {
      startAuto();
    }
  }, { passive: true });

  window.addEventListener('resize', syncAdaptRatio);

  buildDots();
  update();
  if (autoscroll) startAuto();
}

function initAllMainSliders() {
  document.querySelectorAll('.main-slider').forEach(function (el) {
    if (el.dataset.msInitialized) return;
    el.dataset.msInitialized = 'true';
    initMainSlider(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllMainSliders);
} else {
  initAllMainSliders();
}

document.addEventListener('shopify:section:load', function (event) {
  const section = event.target.querySelector('.main-slider');
  if (section && !section.dataset.msInitialized) {
    section.dataset.msInitialized = 'true';
    initMainSlider(section);
  }
});